/* Magazine issues coverflow: the centered issue is the focused card; arrows, dots and side cards move it. */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var focusableSelector = 'a[href], button:not([disabled])';

  function initCoverflow(component) {
    if (!component || component.dataset.magIssuesInitialized === 'true') return;

    var track = component.querySelector('.mag-issues__slider');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.mag-issues__slide')) : [];
    if (!slides.length) return;
    component.dataset.magIssuesInitialized = 'true';

    var prevButton = component.querySelector('.mag-issues__orbit--prev');
    var nextButton = component.querySelector('.mag-issues__orbit--next');
    var dots = Array.prototype.slice.call(component.querySelectorAll('.mag-issues__dot'));
    var currentCounter = component.querySelector('.slider-counter--current');
    var totalCounter = component.querySelector('.slider-counter--total');
    var status = component.querySelector('[data-mag-issues-status]');
    var focused = 0;
    var pending = null;
    var announceTimer = null;
    var trackWidth = track.clientWidth;
    var trackHeight = track.clientHeight;

    slides.forEach(function (slide, index) {
      if (slide.classList.contains('is-focused')) focused = index;
    });

    function shellOf(slide) {
      return slide.querySelector('.mag-issues-card__shell');
    }

    function trackCenter() {
      return track.getBoundingClientRect().left + track.clientLeft + track.clientWidth / 2;
    }

    // Signed distance from the track center to the slide center.
    function centerOffset(slide, center) {
      var slideBox = slide.getBoundingClientRect();
      return slideBox.left + slideBox.width / 2 - (center === undefined ? trackCenter() : center);
    }

    function centeredIndex() {
      var center = trackCenter();
      var closest = focused;
      var closestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(centerOffset(slide, center));
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      return closest;
    }

    // Dawn's slider-component also toggles the arrows and counter on scroll; these run after it.
    function syncControls() {
      if (prevButton) prevButton.disabled = focused === 0;
      if (nextButton) nextButton.disabled = focused === slides.length - 1;
      if (currentCounter) currentCounter.textContent = focused + 1;
      if (totalCounter) totalCounter.textContent = slides.length;
    }

    // Upcoming cards carry a group label; released cards use their dot label (the month).
    function announce() {
      if (!status) return;
      var shell = shellOf(slides[focused]);
      var dot = dots[focused];
      var label = (shell && shell.getAttribute('aria-label')) || (dot && dot.getAttribute('aria-label')) || '';
      var position = focused + 1 + ' ' + (status.dataset.of || '/') + ' ' + slides.length;
      clearTimeout(announceTimer);
      // Waits for the scroll to settle so a jump across several cards is announced once.
      announceTimer = setTimeout(function () {
        status.textContent = label ? label + ', ' + position : position;
      }, 300);
    }

    function render(changed) {
      var active = document.activeElement;
      var hadFocus = false;

      slides.forEach(function (slide, index) {
        var isFocused = index === focused;
        var shell = shellOf(slide);

        if (!isFocused && shell && shell.contains(active)) hadFocus = true;
        slide.classList.toggle('is-focused', isFocused);
        slide.classList.toggle('is-before', index < focused);
        slide.classList.toggle('is-after', index > focused);
        if (isFocused) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
        if (shell) shell.toggleAttribute('inert', !isFocused);
      });

      dots.forEach(function (dot, index) {
        var isActive = index === focused;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      syncControls();

      // Keyboard focus in a card that moved aside follows to the centered card (its shell if it has no links).
      if (hadFocus) {
        // Moving focus already speaks the new card, so the live region stays quiet for this change.
        clearTimeout(announceTimer);
        var shell = shellOf(slides[focused]);
        var target = shell && (shell.querySelector(focusableSelector) || shell);
        if (target) target.focus({ preventScroll: true });
      } else if (changed) {
        announce();
      }
    }

    function goTo(index) {
      var bounded = Math.max(0, Math.min(slides.length - 1, index));
      pending = bounded;
      track.scrollTo({
        left: track.scrollLeft + centerOffset(slides[bounded]),
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    function step(direction) {
      return function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo((pending === null ? focused : pending) + direction);
      };
    }

    // Capturing listeners run before Dawn's own arrow handlers and stop them.
    if (prevButton) prevButton.addEventListener('click', step(-1), true);
    if (nextButton) nextButton.addEventListener('click', step(1), true);

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
      });
    });

    // Side cards are inert, so a click lands on the card box or its slide and centers it.
    track.addEventListener('click', function (event) {
      var slide = event.target.closest('.mag-issues__slide');
      var index = slides.indexOf(slide);
      if (index < 0 || index === focused) return;
      event.preventDefault();
      goTo(index);
    });

    // Any direct input on the track supersedes an arrow target that is still on its way.
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (type) {
      track.addEventListener(
        type,
        function () {
          pending = null;
        },
        { passive: true }
      );
    });

    track.addEventListener(
      'scroll',
      function () {
        var index = centeredIndex();
        if (pending === index) pending = null;
        if (index !== focused) {
          focused = index;
          render(true);
        } else {
          syncControls();
        }
      },
      { passive: true }
    );

    // Re-center when the track resizes (rotation, breakpoint, or late section styles in the editor).
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (track.clientWidth !== trackWidth || track.clientHeight !== trackHeight) {
          trackWidth = track.clientWidth;
          trackHeight = track.clientHeight;
          pending = null;
          track.scrollLeft += centerOffset(slides[focused]);
        }
        syncControls();
      }).observe(track);
    }

    // The inline script centers the opening card before first paint; this covers editor reloads.
    track.scrollLeft += centerOffset(slides[focused]);
    render(false);
  }

  function init(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('.mag-issues__component')) initCoverflow(scope);
    scope.querySelectorAll('.mag-issues__component').forEach(initCoverflow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
